import React from "react";
import UnicliTooltip from "./UnicliTooltip";

export const SendButtonTooltip = (selectedTab, addinType) => {
  if (selectedTab === "chat") {
    return <UnicliTooltip strongLine="Send" mainLine="Send message" />;
  } else {
    return <UnicliTooltip strongLine="Draft" mainLine={addinType == "OUTLOOK" ? "Draft email" : "Draft document"} />;
  }
};
